var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.slideout = function () {
    return {
        slideout: {
            ['x-on:click']: 'click($event, $dispatch)',
        },
        click($event, $dispatch) {
            $dispatch('open-slider');
        },
    }
}